import React from "react";

export function Shell({ children }) {
  return <div className="min-h-screen bg-slate-50 dark:bg-slate-950 text-slate-900 dark:text-white transition-colors">{children}</div>;
}

export function PrimaryButton({ children, className = "", ...props }) {
  return (
    <button
      className={`inline-flex items-center justify-center px-4 py-2 rounded-xl bg-indigo-600 text-white hover:bg-indigo-700 disabled:opacity-50 disabled:cursor-not-allowed transition ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}

export function SecondaryButton({ children, className = "", isDarkMode, ...props }) {
  return (
    <button
      className={`inline-flex items-center justify-center px-4 py-2 rounded-xl border ${isDarkMode ? 'border-slate-600 bg-slate-700 text-slate-200 hover:bg-slate-600' : 'border-slate-200 bg-white text-slate-800 hover:bg-slate-50'} disabled:opacity-50 disabled:cursor-not-allowed transition ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}

export function DangerLink({ children, className = "", ...props }) {
  return (
    <a
      className={`text-sm text-red-600 hover:underline cursor-pointer ${className}`}
      {...props}
    >
      {children}
    </a>
  );
}

export function Chip({ children, className = "", isDarkMode }) {
  return (
    <span
      className={`inline-flex items-center gap-2 rounded-full ${isDarkMode ? 'bg-slate-700 text-slate-300 border-slate-600' : 'bg-slate-100 text-slate-700 border-slate-200'} px-3 py-1 text-xs font-medium border ${className}`}
    >
      {children}
    </span>
  );
}

export function Skeleton({ className = "" }) {
  return <div className={`animate-pulse rounded-xl bg-slate-200/70 ${className}`} />;
}
